import Cookies from "js-cookie";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Middleware = ({ children }) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!Cookies.get("kashanPlusUser")) {
      navigate("/");
      return null;
    }
  }, []);

  return children;
};

export default Middleware;
